export const MESSAGE_REACTION_EMOJIS = ['❤️', '😂', '😮', '😢', '😡', '👍'];

export const filterVisibleMessages = (messages = []) => messages.filter((message) => message?.message_type !== 'unsent' && !(message?.metadata || {}).unsent);

export const getPinnedMessage = (messages = []) => {
  const pinned = messages.filter((message) => (message?.metadata || {}).pinned);
  if (!pinned.length) {
    return null;
  }
  return [...pinned].sort((a, b) => new Date(b?.metadata?.pinned_at || 0).getTime() - new Date(a?.metadata?.pinned_at || 0).getTime())[0];
};

export const summarizeMessageText = (message = {}) => {
  const metadata = message?.metadata || {};
  if ((message?.message_type || 'text') === 'image') return 'Photo';
  if ((message?.message_type || 'text') === 'video') return 'Video';
  if ((message?.message_type || 'text') === 'audio') return 'Voice message';
  if ((message?.message_type || 'text') === 'call_event') return message?.content || 'Call update';
  if (metadata.reply_preview) return metadata.reply_preview;
  return message?.content || '';
};

export const buildReplyPayload = (message = {}, senderName = 'Message') => ({
  id: message.id,
  sender_name: senderName,
  preview_text: summarizeMessageText(message),
  message_type: message.message_type || 'text',
});

export const aggregateReactions = (reactions = {}) => {
  const counts = {};
  Object.values(reactions || {}).forEach((emoji) => {
    if (!emoji) return;
    counts[emoji] = (counts[emoji] || 0) + 1;
  });
  return Object.entries(counts).map(([emoji, count]) => ({ emoji, count }));
};

export const getReactionDetails = (reactions = {}, resolveActorLabel = () => 'Someone') => (
  Object.entries(reactions || {})
    .filter(([, emoji]) => Boolean(emoji))
    .map(([actorId, emoji]) => ({
      actorId,
      emoji,
      label: resolveActorLabel(actorId),
    }))
);

export const formatSeenTimestamp = (value) => {
  if (!value) return '';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '';
  return new Intl.DateTimeFormat('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
  }).format(parsed);
};

/**
 * Resolve the WhatsApp-style tick variant for a message the current user
 * sent. Returns one of 'sent' | 'delivered' | 'seen' | null. When either
 * side has read receipts off the backend clears `read_at` on the message,
 * so the bubble naturally caps out at 'delivered' (grey double tick).
 */
export const resolveOwnStatusVariant = (message) => {
  if (!message || (message.metadata || {}).unsent) return null;
  if (message.read) return 'seen';
  if (message.delivered) return 'delivered';
  return 'sent';
};

export const copyTextToClipboard = async (value = '') => {
  const text = `${value || ''}`;
  if (!text) return false;
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // noop
  }

  try {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.setAttribute('readonly', '');
    textArea.style.position = 'absolute';
    textArea.style.left = '-9999px';
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
    return true;
  } catch {
    return false;
  }
};

export const isEmojiOnlyMessage = (value = '') => {
  const text = `${value || ''}`.trim();
  if (!text) return false;
  const normalized = text.replace(/\s+/g, '');
  return /^(?:\p{Extended_Pictographic}|\p{Emoji_Presentation}|\p{Emoji}\uFE0F)+$/u.test(normalized);
};